export const UPDATE_PUBLIC_INNOVATION_FIELDS_STATE = 'updatePublicInnovationFieldsState'
export const GET_PUBLIC_INNOVATION_FIELDS_URL = 'getPublicInnovationFieldsUrl'
